// Singleton store to maintain latest market data
class MarketDataStore {
    constructor() {
        // Initialize from localStorage if available
        const cachedData = localStorage.getItem('marketDataCache');
        this.marketDataMap = new Map(
            cachedData ? JSON.parse(cachedData) : []
        );
    }

    // Update data for a symbol
    updateMarketData(exchange, token, data) {
        const key = `${exchange}_${token}`;
        this.marketDataMap.set(key, data);
        
        // Cache the updated map in localStorage
        try {
            const mapArray = Array.from(this.marketDataMap.entries());
            localStorage.setItem('marketDataCache', JSON.stringify(mapArray));
        } catch (error) {
            // Handle localStorage quota exceeded
            if (error.name === 'QuotaExceededError') {
                console.warn('LocalStorage quota exceeded, clearing old cache');
                localStorage.removeItem('marketDataCache');
                // Try saving again with just the latest update
                const singleEntry = [[key, data]];
                localStorage.setItem('marketDataCache', JSON.stringify(singleEntry));
            } else {
                console.error('Error caching market data:', error);
            }
        }
    }

    // Get latest data for a symbol
    getMarketData(exchange, token) {
        const key = `${exchange}_${token}`;
        return this.marketDataMap.get(key);
    }

    // Get all market data
    getAllMarketData() {
        return Object.fromEntries(this.marketDataMap);
    }

    // Clear the cache
    clearCache() {
        this.marketDataMap.clear();
        localStorage.removeItem('marketDataCache');
    }

    // Clean old data (older than 24 hours)
    cleanOldData() {
        const oneDayAgo = Date.now() - (24 * 60 * 60 * 1000);
        let hasChanges = false;

        for (const [key, data] of this.marketDataMap.entries()) {
            if (data.timestamp < oneDayAgo) {
                this.marketDataMap.delete(key);
                hasChanges = true;
            }
        }

        // Update localStorage if any entries were removed
        if (hasChanges) {
            const mapArray = Array.from(this.marketDataMap.entries());
            localStorage.setItem('marketDataCache', JSON.stringify(mapArray));
        }
    }
}

// Create singleton instance
const marketDataStore = new MarketDataStore();

// Clean old data periodically (every hour)
setInterval(() => {
    marketDataStore.cleanOldData();
}, 60 * 60 * 1000);

export default marketDataStore; 